import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/OrdenProduccion/ordenproduccion';
import ProduccionNueva from './produccion';

const mstp = state => {
    return {...state.produccion, permisos: state.login.me.permisos}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(ProduccionNueva)
